// Func = limiting Scope for this file
var lastScrollTop = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});
		
		document.querySelector(".tracking-preferences-js").addEventListener('click', function(e){
			e.preventDefault();
			document.querySelector("#teconsent a").click()
		})

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	//For accordion quad
	$('.accordion .accordion__content').hide();
	// $('.accordion .accordion__item:first').addClass("active").find(".accordion__content").slideDown();
	// $('.accordion .accordion__title:first').addClass("active");

	$('.accordion__title').click(function (e) {
		if ($(this).parent().hasClass('active')) {
			$(this).parent().removeClass('active')
			$(this).siblings('.accordion__content').slideUp()
			$(this).removeClass('active')
		} else {
			$('.accordion__item.active .accordion__content').slideUp()
			$('.accordion__item.active').removeClass('active')
			$('.accordion__title').removeClass('active')

			$(this).parent().addClass('active')
			$(this).addClass('active').siblings('.accordion__content').slideDown()
		}
	}) 

	//placerhorder date
	$("input[type=date]").on("input", function () {
		if ($(this).val().length > 0) {
		  $(this).addClass("full");
		} else {
		  $(this).removeClass("full");
		}
	  });

}());


	//Click for booking
	document.getElementById('booking-cta-js').addEventListener('click', function(e){
		e.preventDefault();
		if(!this.classList.contains('open')){
			document.getElementById('booking-engine').classList.add('open');
			document.getElementById('header').classList.add('open-booking');
			this.classList.add('open');
			this.innerHTML="<span>close</span>"
			document.querySelector("body").classList.add('noscroll-m');
		} else {
			this.classList.remove('open');
			document.getElementById('booking-engine').classList.remove('open');
			document.getElementById('header').classList.remove('open-booking');
			this.innerHTML="<span>Book Now</span>";
			document.querySelector("body").classList.remove('noscroll-m')
		}
	});

	//Click for Menu
	document.querySelector('.js-burger-menu').addEventListener('click', function(e){
		e.preventDefault();
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.querySelector("body").classList.add('noscroll');
			document.getElementById('primary-nav').classList.add('open');
			document.getElementById('header').classList.add('open-menu');
			document.querySelector('.text-js').innerHTML = "close";
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.querySelector("body").classList.remove('noscroll')
			document.getElementById('primary-nav').classList.remove('open');
			document.getElementById('header').classList.remove('open-menu');
			document.querySelector('.text-js').innerHTML = "menu";
		}
	});



function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.querySelector("#gallery, #attractions") && !document.getElementById('header').classList.contains('up')){
				
			document.getElementById('header').classList.add('up');

		}

	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//For Menu Tabs
document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
	btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu-restaurant__unitmenu').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
							room.classList.add('active');
					}
			});
	});

	if (i === 0) btn.click();
});

 const select_menu = document.querySelector('#select-menu');
 if (select_menu != null) {
	
	 select_menu.addEventListener('change', _ => {
		document.querySelectorAll('.menu-restaurant__unitmenu').forEach(room => {
			room.classList.remove('active');
			if ( select_menu.value === 'all' || select_menu.value === room.dataset.tag ) {
					room.classList.add('active');
			}
		});
	 });
 }

// Default Intro WRAP BG QUADS
const Introcontent = document.querySelector('#default #intro-content');
if(Introcontent != null){
	const Introcontent_nextel =  Introcontent.nextElementSibling;
	const homeWrapBG = document.createElement('div');
	homeWrapBG.classList.add('WrapBG');
	
	if ( Introcontent ) {
			Introcontent.insertAdjacentElement('beforebegin', homeWrapBG);
			homeWrapBG.appendChild( Introcontent );
			if ( Introcontent_nextel ) homeWrapBG.appendChild( Introcontent_nextel );
	}
}
// Home Intro WRAP BG QUADS
const Introcontent_home = document.querySelector('#home #intro-content');
if(Introcontent_home != null){
	const Introcontent_nextel =  Introcontent_home.nextElementSibling;
	const Introcontent_nextel_two =  Introcontent_home.nextElementSibling.nextElementSibling;
	const homeWrapBG = document.createElement('div');
	homeWrapBG.classList.add('WrapBG');
	
	if ( Introcontent_home ) {
			Introcontent_home.insertAdjacentElement('beforebegin', homeWrapBG);
			homeWrapBG.appendChild( Introcontent_home );
			if ( Introcontent_nextel ) homeWrapBG.appendChild( Introcontent_nextel );
			if ( Introcontent_nextel_two ) homeWrapBG.appendChild( Introcontent_nextel_two );
	}
}



function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
	
	
}
	// SPLIT CURSIVE TITLE TEXT
document.querySelectorAll('h2 span,.gallery-block__sentance,.big-slider__sentance,.uvp span,.dining-section__overlay').forEach(span => {
	let string_old = span.textContent;
	let string_capitalize = string_old.charAt(0).toUpperCase() + string_old.slice(1).toLowerCase();
	const string_new = string_capitalize.split('').map(char => `<div class="char">${char}</div>`).join('');
	span.innerHTML = string_new;
});

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
